module.exports = __webpack_public_path__ + "img/16_24.1ce3c02b.png";